// extracted by mini-css-extract-plugin
export default {"container":"Question_container__XjPI2","content":"Question_content__3vGDv","data":"Question_data__7xAab","qcontent":"Question_qcontent__tyWAk"};